import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const Time1FrameIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M10.16 2.77301C9.92101 2.61401 9.60001 2.78501 9.60001 3.07301V20.928C9.60001 21.216 9.92001 21.387 10.16 21.228L23.251 12.5C23.607 12.263 23.607 11.739 23.251 11.502L10.16 2.77301Z"
        fill={color}
      />
      <path
        d="M5.40001 2.39999H1.80001C1.46864 2.39999 1.20001 2.66862 1.20001 2.99999V21C1.20001 21.3314 1.46864 21.6 1.80001 21.6H5.40001C5.73138 21.6 6.00001 21.3314 6.00001 21V2.99999C6.00001 2.66862 5.73138 2.39999 5.40001 2.39999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

Time1FrameIcon.displayName = 'Time1FrameIcon';
